import { getHost } from '@utils/api-helper/host';
import fetch from '@api/fetchers';

const defaultHost = getHost();

interface AiConfigSuccess {
  daily_limit_exceeded: boolean;
  doubt_number: number;
  sub_cta_details?: {
    text: string;
    cta_text: string;
  };
}

interface AiConfigError {
  message: string;
}

type AiConfigResponse = AiConfigSuccess | AiConfigError;

const API_URL = `${defaultHost}v2/doubts/learner/ai/home/`;

const getInitialUnacademyAiConfig = async (
  goalUID: string
): Promise<AiConfigResponse> => {
  try {
    const url = `${API_URL}?goal_uid=${goalUID}`;

    const response = await fetch(url, {
      method: 'GET',
      useCamelCase: false
    });

    if (response.error) {
      return {
        message: 'Something went wrong'
      } as AiConfigError;
    }

    return response as AiConfigSuccess;
  } catch (error) {
    return {
      message: 'Something went wrong'
    } as AiConfigError;
  }
};

export default getInitialUnacademyAiConfig;
